<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :checkbox-config="checkboxConfig"
            :toolbar-config="toolbarConfig"
            :print-config="printConfig"
            :export-config="exportConfig"
            ref="grid"
            :cellClick="chooseRow"
            :cellDbClick="updateRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
        title="参数管理"
        centered
        :footer="null"
        :maskClosable="false"
        v-model="editModalVisible"
        :width="800"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter";
import api from '@/services/api';
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

import detailForm from "@/pages/web/comm/ecSettingsManage/ecSettingsManageDetail";

const fac = XGrid.factory;

//列表接口
const url = api.comm.ECSETTINGS;

//主键
const rowId = 'id';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("scKey", "参数名", 300),
  fac.makeColumn("scValue", "参数值", 500),
  fac.makeColumn("description", "描述", 500),
]


// 预加载函数 用来加载 列表查询中的通用代码 或其他代码
const formConfig = fac.makeFormConfig(columns, [
  {field: 'scKey'},
  {field: 'scValue'}
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  delData: false,
  export: false,
  import: false,

  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

export default {
  mixins: [GridMixin],
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE'
  // },
  components: {
    detailForm,
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>